export default "__VITE_ASSET__DHj2$XsA__"